/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_verify_identity_requirement_personal_info = /** @type {(inputs: {}) => string} */ () => {
	return `Información personal básica`
};

const en_verify_identity_requirement_personal_info = /** @type {(inputs: {}) => string} */ () => {
	return `Basic personal information`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const verify_identity_requirement_personal_info = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.verify_identity_requirement_personal_info(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("verify_identity_requirement_personal_info", locale)
	if (locale === "es") return es_verify_identity_requirement_personal_info(inputs)
	return en_verify_identity_requirement_personal_info(inputs)
};
export { verify_identity_requirement_personal_info as "verify_identity.requirement_personal_info" }